import { useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchColumns, createColumn } from '../store/columnSlice';

const useColumns = (autoFetch = true, boardId) => {
    const dispatch = useDispatch();
    const columns = useSelector((state) => state.column.list);
    const isLoading = useSelector((state) => state.column.loading);
    const error = useSelector((state) => state.column.error);

    const loadColumns = useCallback((boardId) => { 
        console.log('Passou aqui no loadColumns do useColumns');
        console.log('columns do backend:', columns)
        if (!boardId) return;
        dispatch(fetchColumns(boardId));
    }, [dispatch, boardId]);

    const addColumn = useCallback(
        (columnName) => {
            if (!columnName?.trim()) return;
            dispatch(createColumn({ numBoard: boardId, columnName }));
        },
        [dispatch, boardId]
    );

    useEffect(() => {
        if (autoFetch) {
            loadColumns(boardId);
        }
    }, [autoFetch, loadColumns]);
    return {
        columns,
        isLoading,
        error,
        loadColumns,
        addColumn
    };
};

export default useColumns;